/**
 * Déconnexion du front alumni (RC-248).
 *
 * Le JWT est posé par le front lui-même dans le cookie `t` (login email / mot de passe,
 * cf. HeaderUserLogin). Tant que ce cookie existe, App.js (checkForCookie → authenticateUser)
 * reconnecte l'utilisateur à chaque chargement — y compris dans un nouvel onglet. La déconnexion
 * doit donc supprimer ce cookie côté front, en plus de vider le store Redux.
 */

import { persistor } from "Redux/store";

const EXPIRED = "expires=Thu, 01 Jan 1970 00:00:00 UTC";

// Cookies d'authentification posés par le front (t = JWT) et anciens noms hérités (token, rft).
const AUTH_COOKIES = ["t", "token", "rft"];

/**
 * Expire les cookies d'authentification, avec `path=/` (valeur posée au login) et sans path
 * (cookies posés par d'anciennes versions du front depuis une autre page).
 */
export function clearAuthCookies() {
  AUTH_COOKIES.forEach((name) => {
    document.cookie = `${name}=; ${EXPIRED}; path=/;`;
    document.cookie = `${name}=; ${EXPIRED};`;
  });
}

/**
 * État Redux `auth` d'un utilisateur déconnecté.
 */
export const LOGGED_OUT_AUTH = {
  isConnected: false,
  token: null,
  userConnected: null,
  universityConnected: {},
  isAdmin: false,
  isCreator: false,
  isValidator: false,
  isAlumni: false,
  isPersonnel: false,
};

/**
 * Déconnecte l'utilisateur : vide le store, supprime les cookies puis renvoie sur l'accueil
 * du front alumni (compte local : pas de passage par la déconnexion Shibboleth).
 * @param {Function} handleAuth - dispatch de `updateAuth`
 * @param {string} redirectTo - page d'atterrissage après déconnexion
 */
export async function logoutUser(handleAuth, redirectTo = "/") {
  if (typeof handleAuth === "function") handleAuth(LOGGED_OUT_AUTH);
  clearAuthCookies();
  // redux-persist écrit localStorage de façon asynchrone : sans flush, le rechargement
  // réhydraterait l'ancien état « connecté ».
  await persistor.flush().catch(() => {});
  window.location.href = redirectTo;
}
